//@ts-nocheck
import { useRef, useEffect } from "react";

import { useFullVisionStyle } from "./FullVisionStyles";

import { useFullVisible } from "./useFullVision";

const FullVisionCard = ({ title, description, vendor, price, doClose }) => {
  const { isOpen, handleClosed, handleClick } = useFullVisible();

  const handleCloseClick = (e) => {
    if (e.target.closest(".WrapperSC")) {
      return;
    }

    doClose();
  };

  return (
    // isOpen && (
    <ExternalWrapperSC onClick={handleCloseClick}>
      <WrapperSC className="WrapperSC">
        <ButtonExit onClick={doClose} />
        <TitleSC>{title}</TitleSC>
        <FlexGrow>
          <DescriptionSC>{description}</DescriptionSC>
        </FlexGrow>
        <ContainerRow>
          <VendorCodeSC>{vendor}</VendorCodeSC>
          <PriceSC>{price} ₽</PriceSC>
        </ContainerRow>
      </WrapperSC>
    </ExternalWrapperSC>
    // )
  );
};

const {
  ExternalWrapperSC,
  WrapperSC,
  TitleSC,
  DescriptionSC,
  ContainerRow,
  PriceSC,
  VendorCodeSC,
  ButtonExit,
  FlexGrow,
} = useFullVisionStyle();

export default FullVisionCard;
